// app/javascript/controllers/reports_controller.js
import { Controller } from "stimulus"
import "tom-select/dist/css/tom-select.css"
import TomSelect from "tom-select"

export default class extends Controller {
  initialize() {
    this.reportIndex = 0
  }

  connect() {
    const tomSelectElements = this.element.querySelectorAll('.tom-select')
    tomSelectElements.forEach((selectElement) => {
      const options = {
        plugins: ['remove_button'],
        sortField: 'text',
        maxOptions: 10000,
      }
      new TomSelect(selectElement, options)
    })
  }

  addGrowthReport() {
    const currentResponseSelect = document.getElementById('current-response-select')
    const organizationSelect = document.getElementById('organization-select')
    const previousResponseSelect = document.getElementById('previous-response-select')
    const reportsList = document.getElementById('selected-reports')
    const hiddenInputsDiv = document.getElementById('hidden-inputs')

    const currentResponseId = currentResponseSelect.value
    const currentResponseText = currentResponseSelect.options[currentResponseSelect.selectedIndex]?.text

    const organizationId = organizationSelect.value
    const organizationText = organizationSelect.options[organizationSelect.selectedIndex]?.text

    const previousResponseId = previousResponseSelect.value
    const previousResponseText = previousResponseSelect.options[previousResponseSelect.selectedIndex]?.text

    if (!currentResponseId || !previousResponseId) {
      alert("Please select both current and previous responses.")
      return
    }

    const index = this.reportIndex++
    const reportId = `report-${index}`

    const li = document.createElement('li')
    li.style.fontSize = 'small'
    li.setAttribute('data-report-id', reportId)
    li.innerHTML = `<b>Current</b>: ${currentResponseText}<br><b>Previous</b>: ${previousResponseText}, ${organizationText}`

    const removeButton = document.createElement('button')
    removeButton.textContent = 'Remove'
    removeButton.type = 'button'
    removeButton.classList.add('btn', 'btn-link', 'btn-sm')
    removeButton.addEventListener('click', () => this.removeReport(reportId))
    li.appendChild(removeButton)

    reportsList.appendChild(li)

    this.addHiddenInput(`growth_reports[${index}][current_response_id]`, currentResponseId, reportId, hiddenInputsDiv)
    this.addHiddenInput(`growth_reports[${index}][previous_organization_id]`, organizationId, reportId, hiddenInputsDiv)
    this.addHiddenInput(`growth_reports[${index}][previous_response_id]`, previousResponseId, reportId, hiddenInputsDiv)
  }

  addHiddenInput(name, value, reportId, parentElement) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    input.setAttribute('data-report-id', reportId)
    parentElement.appendChild(input)
  }

  removeReport(reportId) {
    const reportsList = document.getElementById('selected-reports')
    const hiddenInputsDiv = document.getElementById('hidden-inputs')

    const li = reportsList.querySelector(`li[data-report-id="${reportId}"]`)
    if (li) {
      li.remove()
    }

    const inputs = hiddenInputsDiv.querySelectorAll(`input[data-report-id="${reportId}"]`)
    inputs.forEach(input => input.remove())
  }

  selectAll(event) {
    const checkboxes = document.querySelectorAll('.report-checkbox')
    checkboxes.forEach(checkbox => checkbox.checked = event.target.checked)
    this.enableBatchActionButton()
  }

  triggerBatchEmailModal(event) {
    const selectedIds = Array.from(document.querySelectorAll('.report-checkbox'))
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    if (selectedIds.length === 0) {
      alert('Please select at least one report.')
      return
    }

    const url = new URL(event.currentTarget.dataset.url, window.location.origin)
    url.searchParams.set('report_ids', selectedIds)

    $.get(url.toString())
  }

  triggerBatchHiding(event) {
    const selectedIds = Array.from(document.querySelectorAll('.report-checkbox'))
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    const confirmed = window.confirm("Are you sure you want to hide selected reports? It cannot be undone.");

    if (!confirmed) {
      return
    }

    $.ajax({
      url: event.currentTarget.dataset.url,
      type: 'PATCH',
      data: { report_ids: selectedIds }
    })
  }

  triggerBatchDownload(event) {
    const selectedIds = Array.from(document.querySelectorAll('.report-checkbox'))
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    $.ajax({
      url: event.currentTarget.dataset.url,
      type: 'POST',
      data: { report_ids: selectedIds }
    })
  }

  enableBatchActionButton() {
    if (document.querySelectorAll('.report-checkbox:checked').length > 0) {
      document.getElementById('batch-actions-button').classList.remove('d-none')
    } else {
      document.getElementById('batch-actions-button').classList.add('d-none')
    }
  }
}
